import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';
import { useAccountState } from 'contexts/account/account-context';
import { useChartPalette } from 'components/charts/hooks/use-chart-palette';
import ChartThemeScope from 'components/charts/theme/chart-theme-scope';
import Paper from 'components/paper';
import { UserFeatures } from 'types/user-features.enum';
import BenchmarkAnalyticsTabsHeader from './components/benchmark-analytics-tabs-header';
import BenchmarkAnalyticsSubTabs from './components/benchmark-analytics-sub-tabs';

type Props = {
  children?: React.ReactNode;
};

const Canvas = styled(Box)(({ theme }) => ({
  minHeight: '100vh',
  width: '100%',
  padding: theme.spacing(6),
}));

const BenchmarkAnalytics: React.FC<Props> = ({ children }) => (
  <BenchmarkAnalyticsShell>{children}</BenchmarkAnalyticsShell>
);

const BenchmarkAnalyticsShell: React.FC<Props> = ({ children }) => {
  const {
    account: { company },
  } = useAccountState();
  const chartPalette = useChartPalette();
  const hasBenchmarkAnalyticsAccess = company?.userCompanyFeatures.includes(UserFeatures.ShrimpBenchmarkAnalytics) ?? false;

  return (
    <Canvas>
      {hasBenchmarkAnalyticsAccess && (
        <ChartThemeScope>
          <BenchmarkAnalyticsTabsHeader />
        </ChartThemeScope>
      )}
      {hasBenchmarkAnalyticsAccess && <BenchmarkAnalyticsSubTabs />}
      <Paper
        sx={{
          backgroundColor: chartPalette.backgrounds.sunken,
          borderRadius: '16px',
          padding: 6,
        }}>
        {children}
      </Paper>
    </Canvas>
  );
};

export default BenchmarkAnalytics;